import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: { padding: 30 },
  header: { fontSize: 18, marginBottom: 20 },
  row: { marginBottom: 10 },
  label: { fontSize: 12, fontWeight: "bold" },
  value: { fontSize: 12 },
});

export default function ScheduledSectorsPDF({ sectors }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}>Scheduled Print Sectors</Text>
        {sectors.map((entry, i) => {
          const deliveryDate = new Date(entry.scheduled_print_at);
          deliveryDate.setDate(deliveryDate.getDate() + 30);
          return (
            <View key={entry.id} style={styles.row}>
              <Text style={styles.label}>
                {i + 1}. {entry.postcode}
              </Text>
              <Text style={styles.value}>
                Flyers: {entry.flyer_count} | Saturation: {(entry.saturation * 100).toFixed(1)}%
              </Text>
              <Text style={styles.value}>
                Print: {new Date(entry.scheduled_print_at).toLocaleDateString()} | Est. Delivery: {deliveryDate.toLocaleDateString()}
              </Text>
            </View>
          );
        })}
      </Page>
    </Document>
  );
}
